import { IClassname } from '@/lib/shared/model/classname';

export const Balcony = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_404)">
        <path
          d="M8.26855 15.6801V9.29055C8.26855 5.07342 11.7189 1.62305 15.9361 1.62305C20.1532 1.62305 23.6036 5.07342 23.6036 9.29055V15.6801"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.3767 21.4315C30.3767 20.4092 29.4821 19.5146 28.4598 19.5146H3.54041C2.51808 19.5146 1.62354 20.4092 1.62354 21.4315"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.71289 19.5146V30.3769H26.1596V19.5146"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8245 19.5146V30.3769"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.936 19.5146V30.3769"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.0479 19.5146V30.3769"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.26855 9.41895H23.6036"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9361 9.41875L11.5654 2.99121"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.936 9.41875L20.3068 2.99121"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_404">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
